/**
 * @generated SignedSource<<8d40af0ff15359c8408a43a6e4a363c6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutTotals_viewer$data = {
  readonly newDutiesMsgAndTaxEnabled: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDutiesMessage_viewer" | "CheckoutSidebarChargesDisclaimer_viewer">;
  readonly " $fragmentType": "CheckoutTotals_viewer";
};
export type CheckoutTotals_viewer$key = {
  readonly " $data"?: CheckoutTotals_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutTotals_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutTotals_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSidebarChargesDisclaimer_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutDutiesMessage_viewer"
    },
    {
      "alias": "newDutiesMsgAndTaxEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "newDutiesMessageAndTax"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"newDutiesMessageAndTax\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "eed7599ca8dfd4ed579b08f448229681";

export default node;
